'use es6';

import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const FolderNavSelectedCopy = ({
  searchResult,
  searchResults,
  selectedFolder
}) => {
  if (!selectedFolder) {
    return /*#__PURE__*/_jsx("div", {});
  }
  if (searchResults) {
    searchResult = searchResults.first();
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "300",
    as: "div",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "salesContentIndexUI.tableRowHoverButtons.movingItemFromInitialFolderToSelected",
      options: {
        selectedFolderName: selectedFolder.name,
        itemName: searchResult.name,
        count: searchResults ? searchResults.size : 1
      }
    })
  });
};
FolderNavSelectedCopy.propTypes = {
  searchResult: PropTypes.instanceOf(SearchResultRecord),
  searchResults: PropTypes.instanceOf(ImmutableMap),
  selectedFolder: PropTypes.instanceOf(SearchResultRecord)
};
export default FolderNavSelectedCopy;